import React from 'react';
import moment from 'moment';
import { Tooltip } from 'antd';
import { NavLink } from 'react-router-dom';
import { MoreTags } from 'datastake-daf/dist/components';

const cols = (t, module = 'pme', view, show = 'show', activeFilters = {}) => {
  const cols = [
    {
      title: t('ID'),
      dataIndex: 'id',
      key: 'datastakeId',
      show: true,
      ellipsis: true,
      render: id => {
        const redView = view ? view !== 'events' ? view : 'event' : 'event';
        return (
          <NavLink
            className="projectLink"
            to={`/app/${module}/view/${redView}/${id}`}
            {...(show === 'publication' ? {
              target: "_blank"
            } : {})}
          >
            {id}
          </NavLink>
        );
      },
      search: true,
      defaultSortOrder: activeFilters.sortBy === 'datastakeId' ? activeFilters.sortDir : undefined,
      sorter: () => 0 + 0,
      publication: true,
      width: 140,
    },
    {
      title: t('Title'),
      dataIndex: 'eventTitle',
      key: 'eventTitle',
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
      sorter: () => 0 + 0,
      defaultSortOrder: activeFilters.sortBy === 'eventTitle' ? activeFilters.sortDir : undefined,
      show: true,
      primarySearch: true,
      publication: true,
    },
    {
      title: t('Type'),
      dataIndex: 'typeOfEvent',
      key: 'typeOfEvent',
      sorter: (a, b) => ('' + a.typeOfEvent).localeCompare(b.typeOfEvent),
      show: true,
      publication: true,
      onlyEvents: true,
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Date'),
      dataIndex: 'dateOfEvent',
      key: 'dateOfEvent',
      show: true,
      publication: true,
      sorter: () => 0 + 0,
      defaultSortOrder: activeFilters.sortBy === 'dateOfEvent' ? activeFilters.sortDir : undefined,
      search: true,
      searchType: 'date',
      width: 125,
      render: (date, all) => {
        const title = date ? moment(date).format('DD MMM YYYY') : '';
        return <Tooltip title={title}>{title}</Tooltip>
      },
      ellipsis: true,
    },
    {
      title: t('Location'),
      dataIndex: 'location',
      key: 'location',
      show: true,
      search: true,
      publication: true,
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Country'),
      dataIndex: 'country',
      key: 'country',
      show: true,
      search: true,
      publication: false,
      searchType: 'dropdown',
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Province'),
      dataIndex: 'province',
      key: 'province',
      show: true,
      search: true,
      publication: true,
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Territory'),
      dataIndex: 'territory',
      key: 'territory',
      show: true,
      search: true,
      publication: true,
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Category'),
      dataIndex: 'category',
      className: 'event-category-col',
      key: 'category',
      show: true,
      publication: true,
      render: category => {
        return category ? (
          <MoreTags values={category} />
        ) : null
      },
      width: 180,
      search: true,
      searchType: 'dropdown',
    },
    {
      title: t('Version'),
      dataIndex: 'version',
      key: 'version',
      show: false,
      publication: false,
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
      width: 110,
    },
    {
      title: t('Author'),
      dataIndex: 'author',
      key: 'author',
      show: true,
      search: true,
      publication: true,
      width: 120,
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Last Update'),
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      show: true,
      project: true,
      search: false,
      publication: true,
      ellipsis: true,
      render: (updatedAt, item) => {
        const date = item.publishedAt || updatedAt;
        const title = date ? moment(date).format('DD MMM YYYY') : '';
        return <Tooltip title={title}>{title}</Tooltip>
      }
    },
    // {
    //   title: t('Risk Category'),
    //   dataIndex: 'associatedRisk',
    //   key: 'associatedRisk',
    //   show: true,
    //   className: 'd-none',
    //   render: category => {
    //     return category ? (
    //       <>
    //         {(Array.isArray(category) ? category : []).map((c, i) => {
    //           return (
    //             <Tag key={i}>
    //               {c}
    //             </Tag>
    //           )
    //         })}
    //       </>
    //     ) : null
    //   },
    //   search: true,
    //   searchType: 'dropdown',
    // },
  ];
  if (view === 'events') {
    return cols.filter(c => c[show]);
  }

  return cols.filter(c => c[show] && !c.onlyEvents);
}

export default cols;
